import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  DialogContentText,
} from '@mui/material';
import ValidTextField from './ValidTextField';

interface DialogFieldProps {
  title: string;
  placeholder: string;
  open: boolean;
  setOpen: (open: boolean) => void;
  apiDuplicated: boolean;
  setApiDuplicated: (duplicated: boolean) => void;
  checkApiDuplicated: (value: string) => void;
  initValue: string;
  names: string[];
  handleSubmit: () => void;
  apiError: string;
  setApiError: (value: string) => void;
  cypressId: string;
  width?: string;
}

// TODO: refactor with button
const DialogField: React.FC<DialogFieldProps> = ({
  title,
  placeholder,
  open,
  setOpen,
  apiDuplicated,
  setApiDuplicated,
  checkApiDuplicated,
  initValue,
  names,
  handleSubmit,
  apiError,
  setApiError,
  cypressId,
  width = '400px',
}) => {
  const [submitDisabled, setSubmitDisabled] = React.useState(false);

  const handleKeyPress = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      handleSubmit();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="dialog-field"
      PaperProps={{ style: { width } }}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <ValidTextField
          disabled={false}
          placeholder={placeholder}
          initValue={initValue}
          names={names}
          apiDuplicated={apiDuplicated}
          setApiDuplicated={setApiDuplicated}
          checkApiDuplicated={checkApiDuplicated}
          setSubmitDisabled={setSubmitDisabled}
          cypressId={cypressId}
          style={{ width: '100%' }}
          onKeyPress={handleKeyPress}
        />
        {apiError.length > 0 && <DialogContentText color="error">{apiError}</DialogContentText>}
      </DialogContent>
      <DialogActions>
        <Button
          id="cancel"
          data-cy="btn-dialog-field-cancel"
          onClick={() => {
            setOpen(false);
            setApiError('');
          }}
        >
          Cancel
        </Button>
        <Button
          id="submit"
          onClick={handleSubmit}
          color="primary"
          disabled={submitDisabled}
          data-cy="btn-dialog-field-submit"
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogField;
